module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e674c9093c89319075eb0a3aabea06ae.png";